const crmServicesData = [
  {
    title: "Custom CRM Development",
    description:
      "Build reliable, scalable CRM tailored to your processes with analytics and dashboards.",
    bullets: [
      "Analytics & Insights",
      "Integrates with Existing Systems",
      "Modular & Flexible",
      "Personalised Dashboards",
    ],
    minHeight: 420,
  },
  {
    title: "CRM Implementation",
    description:
      "Cloud or on‑premise deployments with environment setup, configuration and rollout.",
    bullets: [
      "End‑to‑End Implementation",
      "Requirement‑Based Config",
      "Reliable Deployment",
      "Reports & KPIs",
    ],
    minHeight: 420,
  },
  {
    title: "CRM Consulting",
    description:
      "Platform selection, roadmap, performance tuning and adoption strategy.",
    bullets: [
      "Current State Assessment",
      "Goal‑Aligned Strategy",
      "Adoption Advisory",
      "Tooling Recommendations",
    ],
    minHeight: 420,
  },
  {
    title: "CRM Integration",
    description:
      "Connect CRM with third‑party apps and internal systems for unified workflows.",
    bullets: [
      "3rd‑Party App Integrations",
      "API/Data Exchange",
      "Real‑Time Sync",
      "Secure Data Flow",
    ],
    minHeight: 420,
  },
  {
    title: "CRM Customization",
    description:
      "Tailor entities, workflows and UX to match your business and teams.",
    bullets: [
      "Advanced Reporting",
      "Scalable & Flexible",
      "Operational Enhancements",
      "Journey Mapping",
    ],
    minHeight: 420,
  },
  {
    title: "CRM Migration & Upgrade",
    description:
      "Secure migration from legacy CRMs with validation, testing and cutover planning.",
    bullets: [
      "Version Upgrades",
      "Cross‑CRM Migration",
      "Data Cleansing",
      "Risk & Testing",
    ],
    minHeight: 420,
  },
  {
    title: "Data Analytics & Insights",
    description:
      "Turn CRM data into actionable insights for sales, marketing and support.",
    bullets: [
      "Decision‑Making",
      "Segmentation",
      "Performance Metrics",
      "Retention",
    ],
    minHeight: 420,
  },
  {
    title: "CRM Maintenance & Support",
    description:
      "Proactive maintenance, updates and enhancements to keep your CRM reliable.",
    bullets: [
      "Proactive Maintenance",
      "Patch Management",
      "Continuous Improvement",
      "Ongoing Support",
    ],
    minHeight: 420,
  },
  {
    title: "Security & Compliance Audits",
    description:
      "Audit CRM for regulations and best practices; strengthen data protection.",
    bullets: [
      "Security Protocols",
      "Risk Assessment",
      "Encryption & Access",
      "Reporting & Governance",
    ],
    minHeight: 420,
  },
];

export default crmServicesData;
